import React from 'react';
import Control from '../../components/UI/Control/Control';
import GeneralMessage from '../../components/UI/GeneralMessage';
import { ProgressSpinner } from 'primereact/progressspinner';
import './TariffUploadForm.css';

const TariffUploadForm = (props) =>{

    const content  = () =>{
        if (props.spinner){
            return (<ProgressSpinner
                strokeWidth="4"
            />);
        } else {
           return( <Control
                name="tariffupload"
                type="fileupload"
                control={props.control}
                uploadHandler={props.uploadHandler}
                label="Select a excel file in XLSX or XLS format."
                accept=".xlsx,.xls"

            />)
        }
    };


    return(
        <div className="animated fadeIn">
            <GeneralMessage
                className="c-msg"
                successMessage={props.successMessage}
                errorList={props.generalErrorList}
            />
            <form noValidate id="tariffUploadForm">
                <div className="container-fluid card p-4 mb-5 animated fadeIn">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="display-5">Upload Tariff File</h2>
                            <hr/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {content()}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
};

export default TariffUploadForm;
